export default {
      id: "letter-usage",
      viewBox: "0 0 64 58",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#letter",
      toString: function () {
        return this.url;
      }
    }